import axios from "axios";
class User {
  tokenkey = Symbol(process.env.REACT_APP_USER_TOKEN_KEY);
  constructor() {}
  setUser(data) {
    return window.localStorage.setItem(this.tokenkey.description, data);
  }
  getUser() {
    
    if(window.localStorage.length>0){
      if(window.localStorage.usertoken){
        const userToken = JSON.parse(window.localStorage.usertoken)
        const storedItem = userToken.sessionTime;
        if (!storedItem) {
          return JSON.parse(window.localStorage.getItem(this.tokenkey.description)) || null; // No data found in localStorage
        }

        const { timestamp, expiration } = storedItem;
        const currentTime = new Date().getTime();
        const timeRemaining = expiration - (currentTime - timestamp);
        // console.log(`Time remaining until expiration: ${timeRemaining / 1000} seconds.`);
        // If the data has expired, remove it from localStorage and return null
        if (currentTime - timestamp > expiration) {
          // localStorage.removeItem(key);
          localStorage.removeItem('usertoken');
          return window.localStorage.removeItem(this.tokenkey.description);
        }
      }
      
    }
    
    return (
      JSON.parse(window.localStorage.getItem(this.tokenkey.description)) || null
    );
  }
  logoutUser() {
    // const token = localStorage.getItem('usertoken');
    localStorage.removeItem('usertoken');
    return window.localStorage.removeItem(this.tokenkey.description);
  }
  loginUser() {
     localStorage.setItem("lref", window.location.href);
    window.location.href = `${process.env.REACT_APP_URL}/login?redirecturl=${window.origin}/verify-login-merchant`;
  }
}
            
const userObj = new User();
export default userObj;
